import { render } from "./Portfolio.vue?vue&type=template&id=b6da144c&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=b6da144c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b6da144c"

export default script